export const QueryKeys = {
  ActiveAccessStats: 'dashboard-v2/active-access-stats',
  AccessFlowUsageStats: 'dashboard-v2/access-flow-usage-stats',
  IntegrationsStats: 'dashboard-v2/integrations-stats',
  NewRequestStats: 'dashboard-v2/new-requests-stats',
  AttackSurfaceReductionStats: 'dashboard-v2/attack-surface-reduction-stats',
  IntegrationUsageStats: 'dashboard-v2/integration-usage-stats',
  ResourceTypesUsageStats: 'dashboard-v2/resource-types-usage-stats',
};
